import { SkipTake } from 'types';
import { ProductScore } from '../../models/product';
import { ScoreExplanation } from '../../models/score';

type IGridTypes = 'current' | 'preview';

export enum PreviewViews {
  CurrentAndPreview = 'CurrentAndPreview',
  PreviewOnly = 'PreviewOnly',
}
interface IcolumnMetadataOptions {
  openModalProduct?: (e, data) => void;
  showProductScore?: (productId) => void;
}

export interface ProductResults {
  total: number;
  items?: any;
  list?: any;
  isFetching?: boolean;
  data?: any;
  count?: number;
}

interface IGrid {
  name?: string;
  type?: IGridTypes;
  title?: string;
  className?: string;
  columnMetadata?: object[];
  columnMetadataOptions?: IcolumnMetadataOptions;
  products: ProductResults;
  scoreLabels?: object[];
  draggable?: boolean;
  flexBasis?: string;
  fetchCurrentData?: () => void;
  selectProduct?: (product: { productId: string; sku: string }) => void;
  loadScoreExplanation: (product: ProductScore) => Promise<ScoreExplanation>;
}
interface IDataGridDouble {
  showGrids?: boolean;
  className?: string;
  name: string;
  current: ProductResults;
  preview: ProductResults;
  isLoading: boolean;
  searchTerm?: string;
  view: PreviewViews;
  getGridData: (skipTake: SkipTake) => void;
  selectProduct: (product: ProductScore) => void;
  showCurrentScoreExplanation: (product: ProductScore) => Promise<ScoreExplanation>;
  showPreviewScoreExplanation: (product: ProductScore) => Promise<ScoreExplanation>;
  defaultText?: string | string[];
  currentPage?: number;
  pageSize?: number;
  onGetPage?: (e) => void;
  onPrevious?: () => void;
  onNext?: () => void;
}

export { IDataGridDouble, IGrid, IGridTypes, IcolumnMetadataOptions };
